import * as Actions from "office/reports/agents/actions";
export default function agentsReducer(currState = null, baseAction) {
    let stateChanges;
    switch (baseAction.type) {
        case Actions.FETCHING:
            let fetchingAction = baseAction;
            return {
                isFetching: true,
                officeId: fetchingAction.officeId,
                officeName: "",
                startDate: fetchingAction.fromDate,
                endDate: fetchingAction.toDate,
                items: null
            };
        case Actions.LOAD:
            let reportAction = baseAction;
            stateChanges = {
                isFetching: false,
                officeId: reportAction.report.officeId,
                officeName: reportAction.report.officeName,
                startDate: reportAction.report.startDate,
                endDate: reportAction.report.endDate,
                items: reportAction.report.items
            };
            return stateChanges;
    }
    return currState;
}
